<template>
    <div class="main">
        <el-container>
            <!-- 左侧菜单 -->
            <meauLeft></meauLeft>

            <!-- 右侧内容 -->
            <el-container>
                <!-- 顶部菜单 -->
                <el-header height="50px" class="headMenu">
                    <meauTop></meauTop>
                </el-header>
                <!-- 主题内容 -->
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import meauLeft from '@/components/layout/meauLeft.vue'
import meauTop from '@/components/layout/meauTop.vue'

export default {
    name: 'HOME',
    components: {
        meauLeft,
        meauTop,
    },
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
body {
    background: #fff;
}
.main {
    width: 100%;
    min-width: 1200px;
    height: 100vh;
}
.headMenu {
    padding: 0 15px;
    background: #fff;
}
.el-main {
    background: #fff;
    border-radius: 5px;
    margin: 10px;
    padding: 15px;
    height: calc(100vh - 70px);
    overflow-y: auto;
    position: relative;
    &::-webkit-scrollbar {
        width: 5px;
        height: 1px;
    }
    &::-webkit-scrollbar-thumb {
        background: #fff;
        border-radius: 30px;
    }
    &::-webkit-scrollbar-track {
        background: #fff;
    }
}
</style>
